import { KhoXuatKhoPageService } from '../kho-xuat-kho-page-service/kho-xuat-kho-page.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { tap, debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { merge, BehaviorSubject, fromEvent } from 'rxjs';
//Datasource
//Service

import { TokenStorage } from '../../../../../../core/auth/_services';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';
import { TimKiemNangCaoDataSource } from '../../../../tim-kiem-nang-cao/datasource/tim-kiem-nang-cao.datasource';

import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel } from '../../../../../../core/_base/crud';
import { Component, ChangeDetectionStrategy, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
//Model
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { JsPDFFontService } from '../../../dung-chung/__services/pdf-custom-font.service';

@Component({
	selector: 'm-kho-xuat-page-file',
	templateUrl: './kho-xuat-page-file.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})
export class KhoXuatPageFileComponent implements OnInit {
	// Config Form 
	CONFIG: CommonConFig;
	Id: number = 0;
	fixedPoint = 2;    
	private defaultSelected = 0
	private selection: number = 0;
	listXuatKho: any[] = [];  
	
	//#region Constructor
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private dungChung : DungChungService,
		private khoxuatkho : KhoXuatKhoPageService,
		public dialog: MatDialog,
		private router: Router,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private tokenStorage: TokenStorage,
		private pdfCustomService: JsPDFFontService,
		public dialogRef: MatDialogRef<KhoXuatPageFileComponent>,
		private layoutUtilsService: LayoutUtilsService) {
			this.dialogRef.disableClose = true;
		}
	//#endregion Constructor

	//#region Load Data
	ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.Id = this.data.Id;
		this.dialogRef.keydownEvents().subscribe(event => {
			if (event.key == "Escape") {
				this.back();
			}
		});
		this.khoxuatkho.danhSachKhachHang_XuatKhoTheoPhieu(this.Id).subscribe(res => {
			if(res && res.status == 1){
				this.listXuatKho = res.data;
				this.changeDetect.detectChanges();
			}else{
				
				this.layoutUtilsService.showInfo("Không thể lấy được danh sách xuất kho");
			}
		})
	}

	ngAfterViewInit() {
		this.changeDetect.detectChanges();
	}

	back(){
		this.dialogRef.close({});
	}

	exportExcelInfo(){
		let item = this.listXuatKho[this.selection];
		// console.log(item);
		// return;
		let head = [['#', 'Mã hàng', 'Tên hàng', 'Số lô', 'Hạn sử dụng', 'Mã kho','ĐVT','Số lượng','Đơn giá','Thành tiền']]
		let dataTable =[{
			'#': 'A',
			'MaHH': 'B',
			'TenHH': 'C',
			'Solo': 'D',
			'HanSuDung': 'E',
			'MaKho': 'F',
			'TenDVT': 'G',
			'SL': '1',
			'DG': '2',
			'TT': '3'
		}];

		var total = 0;
		for(let i = 0; i < item.Childs.length; i++){
			let element = item.Childs[i];
			dataTable.push({
				'#' : (i + 2) + '',
				'MaHH': element.MaHH,
				'TenHH': element.TenHH,
				'Solo': element.Solo,
				'HanSuDung': element.HanSuDung == null ? '' : this.getFormatDate(element.HanSuDung),
				'MaKho': item.MaKho,
				'TenDVT': element.TenDvt,
				'SL': element.Soluongthucxuat,
				'DG': '',
				'TT': ''
			});
		}
		let totalSL = 0;
		var dataRow = [];
		dataTable.forEach((element,index) =>{
			if(index == 0){
				dataRow.push([
					{content: element["#"], styles: { halign: 'center' }},
					{content: element.MaHH, styles: { halign: 'center' }},
					{content: element.TenHH, styles: { halign: 'center' }},
					{content: element.Solo, styles: { halign: 'center' }},
					{content: element.HanSuDung, styles: { halign: 'center' }},
					{content: element.MaKho, styles: { halign: 'center' }},
					{content: element.TenDVT, styles: { halign: 'center' }},
					{content: index == 0 ? '1' : '', styles: { halign: 'center' }},
					{content: index == 0 ? '2' : '', styles: { halign: 'center' }},
					{content: index == 0 ? '3' : '', styles: { halign: 'center' }},
				])
			}
			else{
				totalSL += Number(element.SL);
				dataRow.push([
					{content: index, styles: { halign: 'center' }},
					{content: element.MaHH, styles: { halign: 'center' }},
					{content: element.TenHH, styles: { halign: 'center' }},
					{content: element.Solo, styles: { halign: 'center' }},
					{content: element.HanSuDung, styles: { halign: 'center' }},
					{content: item.MaKho ? item.MaKho : element.MaKho, styles: { halign: 'center' }},
					{content: element.TenDVT, styles: { halign: 'center' }},
					{content: this.f_number(element.SL), styles: { halign: 'right' }},
					{content: ''},
					{content: ''},
				])
			}
		})
		dataRow.push([
			{content: (''), styles: { halign: 'center' }},
			{content:'Cộng', colSpan: 3, styles: { halign: 'center', fontStyle: 'bold', } }, 
			{content:''},
			{content:''},
			{content: ``},
			{content: `${totalSL == 0 ? '' : this.f_number(totalSL)}`, styles: { halign: 'right' }},
		])

		var doc = new jsPDF();
		this.pdfCustomService.AddFontRoboto(doc);
		let x = 10; let y = 15;
		var xOffset = (doc.internal.pageSize.width / 2 - 10);

		doc.setFontSize(10);
		doc.setFontType("normal");
		doc.text(x,y, 'CÔNG TY TNHH THỰC PHẨM NFC');
		y += 7;
		doc.text(x,y, 'Đường số 8, KCX Nhơn Trạch 1, xã Phước Thiên, huyện Nhơn Trạch, tỉnh Đồng Nai, Việt Nam');
		y += 12;

		doc.setFontType("bold");
		doc.setFontSize(12);
		var textWidth = doc.getStringUnitWidth('PHIẾU XUẤT KHO') * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
		doc.text(textOffset, y, 'PHIẾU XUẤT KHO');
		y += 7;

		doc.setFontSize(10);
		doc.setFontType("bolditalic");
		var formatDate = this.getFormatDate(item.NgayXuat).split("/")
		var textWidth = doc.getStringUnitWidth('Ngày ' + formatDate[0] + ' tháng ' + formatDate[1] + ' năm ' + formatDate[2]) * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
	
		doc.text(textOffset, y, 'Ngày ' + formatDate[0] + ' tháng ' + formatDate[1] + ' năm ' + formatDate[2]);
		doc.setFontType("normal");
		doc.text(160, y, 'TK nợ:');
		y += 7;
		var textWidth = doc.getStringUnitWidth('Số: ' + item.SoPhieu) * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
		doc.text(textOffset, y, 'Số: ' + item.SoPhieu);
		doc.text(160, y, 'TK có:');
		y += 12;

		doc.text(x,y, '- Họ và tên người nhận hàng: ');
		doc.text(x + 50,y, item.TenKH);
		y += 7;

		doc.text(x,y, '- Địa chỉ (bộ phận): ');
		doc.text(x + 30,y, item.DiaChi); 
		y += 7;

		doc.text(x,y, '- Lý do xuất: ');
		doc.text(x + 22, y, ''+item.LyDoXuat); 
		y += 7;

		doc.text(x,y, '- Xuất tại kho: '); 
		doc.text(x + 25, y, ''+ item.TenKho); 

		doc.text(x + doc.internal.pageSize.width / 2,y, 'Địa điểm: ' + ''); y += 7;

		y +=10;
		(doc as any).autoTable({
			head: head,
			body: dataRow,
			styles: { 
				font: 'Roboto-Regular',
      			fontStyle: 'normal',
				fontSize: 10, 
			},
			headStyles:{
				font: 'Roboto-Regular',
				fontStyle: 'bold',
				fontSize: 11,
			},
			margin: { top: y, left: 10 },
			theme: 'grid'
		})
		y +=15 + (dataRow.length * 10);

		doc.text(x,y, '- Số tiền bằng chữ: ');
		doc.setFontType("normal");
		if(total > 0){
			doc.text(x + 30,y, FunctionPublic.convertCurrencyFromNumToStr(total.toString()));
		}
		y += 7;

		doc.text(x,y, '- Số chứng từ gốc kèm theo: '); y += 10;

		var toDay = new Date();
		var d = toDay.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).split("/");
		doc.setFontType("italic");
		doc.text(x + 142 , y, 'Ngày ' + d[1] + ' tháng ' + d[0] + ' năm ' + d[2]); y += 10;

		let widthA4 = doc.internal.pageSize.width - 10;
		let posBegin = 10;

		doc.setFontType("bold");
		doc.text(posBegin, y, 'Người lập phiếu'); posBegin = posBegin + widthA4 / 5;
		doc.text(posBegin, y, 'Người nhận hàng'); posBegin = widthA4 / 2;
		doc.text(posBegin, y, 'Thủ kho'); posBegin = posBegin + widthA4 / 5;
		doc.text(posBegin, y, 'Kế toán trưởng'); posBegin = posBegin + widthA4 / 5;
		doc.text(posBegin, y, 'Giám đốc'); posBegin = posBegin + widthA4 / 5;
		posBegin = 13;
		y += 7;
		
		doc.setFontType("normal");
		doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = posBegin + widthA4 / 5;
		doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = -2 + widthA4 / 2;
		doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = posBegin + 5 + widthA4 / 5;
		doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = posBegin - 5 + widthA4 / 5;
		doc.text(posBegin, y, '(Ký, họ tên)');  posBegin = posBegin + widthA4 / 5;
		y += 40;

		doc.text(10, y, item.TenNguoiTao);
		doc.text( widthA4 / 2 - 10, y, "TRẦN THỊ THƯƠNG");

		//doc.output('dataurlnewwindow')

		// Download PDF document  
		doc.save(item.SoPhieu + '_Report.pdf');
	}
	//#endregion Load Data

	formatNumber(item: string){
		if(item == '' || item == null || item == undefined)	return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-'+ this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if(value == '-1') return '';
		if (value == null || value == undefined || value == '') value = '0';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}

	getFormatDate(v: string = '') {
        if (v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}

	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER(item);
	}
}
